export { links, loader, meta, default } from "./$articleId.$articleName";
